// extracted by mini-css-extract-plugin
module.exports = {"submit-button-details":"form_submit-button-details__fp2GC"};